import { render, staticRenderFns } from "./AddOpCardForm.vue?vue&type=template&id=806e346a&"
import script from "./AddOpCardForm.vue?vue&type=script&lang=ts&"
export * from "./AddOpCardForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports